import React from 'react';
import Container from '../common/container';
import Image from 'next/image';
import { NextLink, Translate, useTranslate } from '~/i18n';

const DiscoverCard: React.FC<DiscoverDataItem> = ({ name, description, category }) => {
   return (
      <NextLink href={`/madinah/destinations/${category}`}>
         <div className="flex flex-col w-full h-full gap-5 p-4 transition-all bg-white hover:transition-all hover:bg-[#4d9272]/5 cursor-pointer rounded-lg">
            <div className="text-2xl underline text-madinah-primary">{name}</div>
            <div className="text-xl font-normal text-madinah-gray">{description}</div>
         </div>
      </NextLink>
   );
};

interface DiscoverDataItem {
   name: React.JSX.Element;
   description: React.JSX.Element;
   category: string;
}

interface DiscoverProps {
   data: DiscoverDataItem[];
}

const Discover: React.FC<DiscoverProps> = ({ data }) => {
   const { locale } = useTranslate();
   const discoverData = [
      {
         name: <Translate id="common:discover item 1 title" />,
         description: <Translate id="common:discover item 1 subtitle" />,
         category: locale === 'ar' ? 'الإقامة' : 'accommodations',
      },
      {
         name: <Translate id="common:discover item 2 title" />,
         description: <Translate id="common:discover item 2 subtitle" />,
         category: locale === 'ar' ? 'التنقل' : 'transportation',
      },
      // {
      //    name: <Translate id="common:discover item 3 title" />,
      //    description: <Translate id="common:discover item 3 subtitle" />,
      //    category: 'historical-locations',
      // },
      {
         name: <Translate id="common:discover item 4 title" />,
         description: <Translate id="common:discover item 4 subtitle" />,
         category: locale === 'ar' ? 'دروب-المدينة' : 'madinah-roads',
      },
   ];

   return (
      <section className="w-full h-full py-8 lg:py-16">
         <Container>
            <div className="flex flex-col w-full gap-8 lg:gap-12">
               <h2 className="text-2xl font-normal text-black lg:text-5xl lg:max-w-4xl">
                  <Translate id="common:discover section title" />
               </h2>

               <Image
                  src="/madinah/home/discover.png"
                  width={1920}
                  height={1080}
                  alt="Discover"
                  className="rounded-2xl"
               />

               <div className="grid w-full grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                  {(data?.length ? data : discoverData)?.map((item, index) => (
                     <DiscoverCard
                        key={index}
                        name={item.name}
                        description={item.description}
                        category={item.category}
                     />
                  ))}
               </div>
            </div>
         </Container>
      </section>
   );
};

export default Discover;
